<template>
  <section class="py-5 container">
    <h4>Factoraje - Cotización #{{ cotizacionId }}</h4>
    <hr />
    <div class="d-flex justify-content-end align-items-center gap-2 mb-4">
      <router-link
        :to="{
          name: 'factoraje',
        }"
      >
        <ArgonButton color="light" size="sm" icon="ri-arrow-left-line">
          Regresar
        </ArgonButton>
      </router-link>
      <a
        class="btn btn-light btn mb-0 d-flex flex-row align-items-center justify-content-center gap-2 btn-sm"
        :href="`${urlEndpoint}public/cotizaciones/factoraje/${cotizacionId}/previsualizar?download=true`"
        target="_blank"
        ><i class="ri ri-download-line me-2"></i>Descargar</a
      >
    </div>
    <iframe
      :src="`${urlEndpoint}public/cotizaciones/factoraje/${cotizacionId}/previsualizar#toolbar=0`"
      title="PDF embebido"
      allowfullscreen
      class="w-100 border rounded"
      style="height: 95vh"
    ></iframe>
  </section>
</template>

<script setup>
import { useRoute } from "vue-router";
import ArgonButton from "@/components/ArgonButton.vue";
import { useCotizacionFactoraje } from "@/composables/useCotizacionFactoraje";
import useUtil from "@/composables/useUtil";

const route = useRoute();
const cotizacionId = route.params.cotizacion_id;
const { urlEndpoint } = useUtil();

const { getCotizacionById } = useCotizacionFactoraje();
getCotizacionById(cotizacionId);
</script>
